<style></style>
<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          Progress Report
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            진도관리 → Progress Report
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <template v-if="props.strFullName == 'ALL'">
              <tr
                v-for="(record, i) in props.records"
                v-bind:key="record.intHWNo"
              >
                <td scope="col">{{ i + 1 }}</td>
                <td style="text-align: center">
                  <Business v-if="record.t1" :biz="record.t1" />
                </td>
                <td style="text-align: center">{{ record.username }}</td>
                <td style="text-align: center">
                  <Student :student="record" />
                </td>
                <td style="text-align: center">{{ record.cWS_LIS }}</td>
                <td style="text-align: center">{{ record.cWS_PRE }}</td>
                <td style="text-align: center">{{ record.cWS_TEST }}</td>
                <td style="text-align: center">{{ record.cWS_SHA }}</td>
                <td style="text-align: center">{{ record.cWW_PRA }}</td>
                <td style="text-align: center">{{ record.cWW_QUIZ }}</td>
                <td style="text-align: center">{{ record.cWW_PRE }}</td>
                <td style="text-align: center">{{ record.cWW_TEST }}</td>
                <td style="text-align: center">{{ record.cSS_PRA }}</td>
                <td style="text-align: center">{{ record.cSS_SHA }}</td>
                <td style="text-align: center">{{ record.cSS_PRT }}</td>
                <td style="text-align: center">{{ record.cSS_TEST }}</td>
                <td style="text-align: center">{{ record.cSW_PRA }}</td>
                <td style="text-align: center">{{ record.cSW_QUIZ }}</td>
                <td style="text-align: center">{{ record.cSW_TEST }}</td>
                <td style="text-align: center">{{ record.cDU_PRA }}</td>
                <td style="text-align: center">{{ record.cDU_LIVE }}</td>

                <td style="text-align: center">{{ record.tt }}</td>
              </tr>
            </template>
            <template v-else-if="props.strFullName == 'American'">
              <tr
                v-for="(record, i) in props.records"
                v-bind:key="record.intHWNo"
              >
                <td scope="col">{{ i + 1 }}</td>
                <td style="text-align: center">
                  <Business v-if="record.t1" :biz="record.t1" />
                </td>
                <td style="text-align: center">{{ record.username }}</td>
                <td style="text-align: center">
                  <Student :student="record" />
                </td>
                <td style="text-align: center">{{ record.Step_Type }}</td>
                <td style="text-align: center">{{ record.Step_value }}</td>
                <td style="text-align: center">{{ record.Grade }}</td>
                <td style="text-align: center">{{ record.Step }}</td>
                <td style="text-align: center">{{ record.Subject }}</td>
                <td style="text-align: center">{{ record.Time }}</td>
                <td style="text-align: center">{{ record.ActivityCode }}</td>
                <td style="text-align: center">{{ record.duration }}</td>
                <td style="text-align: center">
                  {{ record.h_date.substr(2, 8) }}
                </td>
                <td>
                  <a
                    target="_blank"
                    :href="
                      'https://bizstudy.useschool.co.kr/american_school/Language_course/Bridge_Free.asp?Activity_no=' +
                      record.ActivityCode +
                      '&Step_no=' +
                      record.Step_no
                    "
                  >
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      style="font-size: 13px"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </a>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr
                v-for="(record, i) in props.records"
                v-bind:key="record.intHWNo"
              >
                <td scope="col">{{ i + 1 }}</td>
                <td style="text-align: center">
                  <Business v-if="record.t1" :biz="record.t1" />
                </td>
                <td style="text-align: center">{{ record.username }}</td>
                <td style="text-align: center">
                  <Student :student="record" />
                </td>

                <td style="text-align: center">
                  {{ record.Step_Type + " " + record.Step_value }}
                </td>
                <td style="text-align: center">{{ record.ActivityCode }}</td>
                <td style="text-align: center">{{ record.strActTitle }}</td>
                <td style="text-align: center">{{ record.bcode }}</td>
                <td style="text-align: center">{{ record.duration }}</td>
                <td style="text-align: center">
                  {{ record.h_date.substr(2, 8) }}
                </td>
                <td style="background: #f8f8f8">
                  <a
                    target="_blank"
                    :href="
                      'https://bizstudy.useschool.co.kr/report/report_detail.asp?hno=' +
                      record.intHNo
                    "
                    ><button class="btn btn-danger btn-sm">View</button></a
                  >
                </td>
              </tr>
            </template>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid_Report.vue";
import Student from "../components/detail_pages/Student.vue";
import TreeBtn from "../components/treeBtn";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    TreeBtn,
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    console.log(this.$root.guiPerm);
    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.config.columns.splice(1, 1);
    }
  },
  methods: {},
  data() {
    return {
      config: {
        name: "progress_report",
        req_endpoint: "/studies/progress_report",
        default_limit: 20,
        search_fields: [],
        columns: [],
        disable_init_search: true,
      },
      records: [],
      strFullName: "",
      searchKeyword: "",
      searchBiz: "",
      sType: "",
      sStatus: "",
      offset: 0,
      total: 0,
      index: 0,
      classlists: [],
      studentlists: [],
      classselected: "",
      customValue: 1,
      stotal: 0,
      ActivityValue: "LA259",
      ActivityList: [],
      sb1: "",
      details: "",
      students: "",
      sallChecked: false,
      selData: {},
      allChecked: false,
    };
  },
  computed: {
    checked: function () {
      return this.records.filter((record) => record.checked && !record.chrDone);
    },
  },
};
</script>
